import Promise from 'bluebird';
import { getErrorString } from './utils';

const CLIENT_NAME = 'bingadsweb';
const MAX_RETRY_COUNT = 3;
const RETRY_INTERVALS = [1000, 3000, 5000, 10000];

export const getImportRecommendationApi = ({
  odata,
  userId,
  logger,
}, retryInternals = RETRY_INTERVALS) => {
  const get = () => {
    const url = `Customers()/Accounts()/ImportRecommendations?$Filter=userId+eq+${userId}`;
    const getWithRetry = (retryCount, resolve, reject) => {
      odata.get(url).then((data) => {
        const { value: recommendations } = data || {};
        resolve(recommendations);
      }).catch((err) => {
        if (retryCount < MAX_RETRY_COUNT) {
          logger.logTrace(`[ImportCalloutCard] Failed to get recommendations, error:${getErrorString(err)}, retryCount:${retryCount}`);
          setTimeout(
            () => getWithRetry(retryCount + 1, resolve, reject),
            retryInternals[retryCount]
          );
        } else if (
          (err && err.readyState === 0) ||
          (err && err.responseText && err.responseText.includes('HTTP Error 400. The request verb is invalid.')) ||
          (err && err.responseText && err.responseText.includes('TokenExpired'))) {
          //
          // ignore client side errors
          logger.logTrace(`[ImportCalloutCard] Failed to get recommendations with client error, error:${getErrorString(err)}, retryCount:${retryCount}`);
          resolve(null);
        } else {
          logger.logError(`[ImportCalloutCard] Failed to get recommendations, error:${getErrorString(err)}, retryCount:${retryCount}`);
          reject(err);
        }
      });
    };
    return new Promise((resolve, reject) => getWithRetry(0, resolve, reject));
  };

  const patch = ({ id, status }) => {
    const url = `Customers()/Accounts()/ImportRecommendations(${id})`;
    const patchData = {
      '@odata.type': '#Model.ImportRecommendation',
      Id: id,
      Status: status,
      DismissalExpirationDateTime: null,
      UserId: userId,
      ClientName: CLIENT_NAME,
    };
    const patchWithRetry = (retryCount, resolve, reject) => {
      odata.patch(url, { data: patchData }).then((updatedRecommendation) => {
        // check updated status
        const { Status: updatedStatus } = updatedRecommendation || {};
        if (status !== updatedStatus) {
          logger.logTrace(`[ImportCalloutCard] Failed to update status for recommendation, actual_status:${updatedStatus}, expect_status:${status}, RID:${id}`);
        }
        resolve(updatedRecommendation);
      }).catch((err) => {
        if (retryCount < MAX_RETRY_COUNT) {
          logger.logTrace(`[ImportCalloutCard] Failed to update status for recommendation, error:${getErrorString(err)}, retryCount:${retryCount}, RID:${id}`);
          setTimeout(
            () => patchWithRetry(retryCount + 1, resolve, reject),
            RETRY_INTERVALS[retryCount]
          );
        } else if (
          (err && err.readyState === 0) ||
          (err && err.responseText && err.responseText.includes('HTTP Error 400. The request verb is invalid.')) ||
          (err && err.responseText && err.responseText.includes('TokenExpired'))) {
          //
          // ignore client side errors
          logger.logTrace(`[ImportCalloutCard] Failed to update status for recommendation with client error, error:${getErrorString(err)}, retryCount:${retryCount}, RID:${id}`);
          resolve(null);
        } else {
          logger.logError(`[ImportCalloutCard] Failed to update status for recommendation, error:${getErrorString(err)}, retryCount:${retryCount}, RID:${id}`);
          reject(err);
        }
      });
    };
    return new Promise((resolve, reject) => patchWithRetry(0, resolve, reject));
  };

  return { get, patch };
};
